import { useState } from 'react'
import { Link } from 'react-router-dom'
import { api } from '../services/api.js'
import { usePageTitle } from '../hooks/usePageTitle.js'

export default function ForgotPasswordPage() {
  usePageTitle('Reset password')
  const [email, setEmail]     = useState('')
  const [sent, setSent]       = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError]     = useState(null)

  async function handleSubmit(e) {
    e.preventDefault()
    setLoading(true); setError(null)
    try {
      await api.post('/auth/forgot-password', { email })
      setSent(true)
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <span className="auth-logo">Genealogic</span>
        <p className="auth-tagline">Reset your password</p>

        {sent ? (
          <div className="auth-notice">
            <p>If an account exists for <strong>{email}</strong>, you'll receive a reset link shortly. Check your inbox.</p>
            <Link to="/login" className="btn btn-gold" style={{ marginTop: '1.25rem', display: 'block', textAlign: 'center' }}>
              Back to sign in
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <label>
              Email address
              <input
                type="email"
                value={email}
                placeholder="you@example.com"
                onChange={e => setEmail(e.target.value)}
                required
                autoFocus
              />
            </label>
            {error && <p className="error">{error}</p>}
            <button type="submit" className="btn btn-gold" disabled={loading}>
              {loading ? 'Sending…' : 'Send reset link'}
            </button>
          </form>
        )}

        {!sent && (
          <p className="auth-switch">
            Remember it? <Link to="/login">Sign in</Link>
          </p>
        )}
      </div>
      <a href="https://genealogic.ai" className="auth-back">← Back to genealogic.ai</a>
    </div>
  )
}
